import css from "@styled-system/css";
import styled from "styled-components";

import Label from "../../Label/Label";
import { StyledLabelProps } from "./ProxyBidDynamicLabel.types";

export const StyledSecondaryButton = styled.button`
	border: none;
	background-color: transparent;
	padding: 0;
	margin: 0;
	font-weight: 700;
	font-size: 18px;
	line-height: 24px;
	cursor: pointer;
	${(props) => ({ color: props.theme.palette.hexFor("primary_accent_600") })}
`;

export const StyledLabel = styled(Label)<StyledLabelProps>`
	flex: 1;
  opacity 1;
	&.transition {
		opacity: 0;
    transition: opacity 500ms ease-in-out;
	}
	${({ variant, theme }) => {
		if (variant === "success") {
			return `color: ${theme.palette.hexFor("semantic_success_700")};`;
		} else if (variant === "error") {
			return `color: ${theme.palette.hexFor("semantic_error_700")}`;
		} else {
			return "";
		}
	}}
`;
